import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import styles from './Layout.module.css';

export function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    await logout();
    navigate('/login');
  }

  return (
    <div className={styles.shell}>
      <nav className={styles.nav}>
        <NavLink to="/"       className={({ isActive }) => isActive ? styles.linkActive : styles.link}>Feuille de temps</NavLink>
        {(user?.isManager || user?.isResponsible) &&
          <NavLink to="/reports" className={({ isActive }) => isActive ? styles.linkActive : styles.link}>Rapports</NavLink>}
        {(user?.isManager || user?.isResponsible) &&
          <NavLink to="/charts" className={({ isActive }) => isActive ? styles.linkActive : styles.link}>Graphiques</NavLink>}
        {user?.isManager &&
          <NavLink to="/admin" className={({ isActive }) => isActive ? styles.linkActive : styles.link}>Admin</NavLink>}
        <span className={styles.spacer} />
        <span className={styles.who}>{user?.fullName}</span>
        <button className={styles.logoutBtn} onClick={handleLogout}>Déconnexion</button>
        <span className={styles.copyright}>
          <span>Copyright 2026</span>
          <span>{__BUILD_DATE__} · {__GIT_VERSION__}</span>
        </span>
        <span className={styles.brand}>Spirtech</span>
      </nav>

      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
